module.exports = __webpack_public_path__ + "static/media/insect(24).63bb2357.PNG";